/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module CportalModule */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import './proxy-widget.component.less';
import { CPortalPageStore } from '../cportal-page.store';
import * as l10n from './proxy-widget.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * Widget to display Proxy within the cloud service page.
 * @author Deepak Chaudhary
 */
@Component({
    selector: 'proxy-widget',
    templateUrl: './proxy-widget.component.html',
})
export class ProxyWidgetComponent {
    public readonly useSplitProxyStatus$ = this.cPortalPageStore.useSplitProxyStatus$;

    public readonly l10nKeys = l10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly cPortalPageStore: CPortalPageStore,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
